import React from "react";
import { Contact } from "../components/contact";
import { ContactInfo } from "../components/ContactInfo";
import SEO from "../components/SEO";

export const ContactPage = ({ data, contactInfoData, lang, isDarkMode }) => {
  const currentLang = lang ? lang.toLowerCase() : 'tr';

  const seoContent = {
    tr: {
      title: "İletişim",
      description: "Akay Conseil ile iletişime geçin. Hukuk danışmanlığı hizmetlerimiz hakkında bilgi almak için bize ulaşın.",
      keywords: "iletişim, hukuk danışmanlığı, randevu, iletişim bilgileri"
    },
    en: {
      title: "Contact",
      description: "Contact Akay Conseil. Reach out to us for information about our legal consulting services.",
      keywords: "contact, legal consulting, appointment, contact information"
    },
    fr: {
      title: "Contact",
      description: "Contactez Akay Conseil. Contactez-nous pour obtenir des informations sur nos services de conseil juridique.",
      keywords: "contact, conseil juridique, rendez-vous, informations de contact"
    }
  };

  const seo = seoContent[currentLang] || seoContent.tr;

  return (
    <div style={{ paddingTop: '80px' }}>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/contact"
        lang={currentLang}
        image="img/law-photo1.png"
      />
      <ContactInfo data={contactInfoData} lang={lang} />
      <Contact data={data} lang={lang} isDarkMode={isDarkMode} />
    </div>
  );
};